import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const mediaFileEntity: Entity = {
  model: model,
  repository: repository,
}

export default mediaFileEntity
